import React from 'react'

import { LowerRegions } from '@/modules/configs/region'

import { getStaticSiteConfig } from './getStaticSiteConfig'
import { Navbar } from './Navbar'
import { useLocaleCookie } from './useLocaleCookie'
import { usePreserveEnglish } from './usePreserveEnglish'
import { usePreserveFrench } from './usePreserveFrench'
import { usePreservePortuguese } from './usePreservePortuguese'
import { usePreserveTurkish } from './usePreserveTurkish'
import { useUpdatedMenu } from './useUpdatedMenu'

const GeneralNavbar = ({ region }: { region: LowerRegions }) => {
  const {
    products,
    isExchange,
    exchange,
    isDefi,
    defi,
    isEco,
    eco,
    company,
    company_desktop,
    products_desktop,
    isShowNFT,
    isShowPrice,
    isShowLanguages,
    logoHref,
    languages,
    learn,
    isShowGeoIcon,
    learn_desktop,
  } = getStaticSiteConfig(region)

  // NOTE: the order is important,
  // 1. read and set the preferred language
  // 2. set pt or pt-BR on different sites
  // 3. if it's EEA, should ignore language settings, show english
  // 4. if it's TR, should change any language to English except user already choose en or tr
  useLocaleCookie()
  usePreservePortuguese(region)
  usePreserveEnglish(region)
  usePreserveTurkish(region)
  usePreserveFrench(region)

  const {
    products: updatedProducts,
    products_desktop: updatedProductsDesktop,
  } = useUpdatedMenu(region, products, exchange, defi, products_desktop)

  return (
    <Navbar
      products={updatedProducts}
      isExchange={isExchange}
      exchange={exchange}
      isDefi={isDefi}
      defi={defi}
      isEco={isEco}
      eco={eco}
      company={company}
      company_desktop={company_desktop || []}
      products_desktop={updatedProductsDesktop}
      isShowNFT={isShowNFT}
      isShowPrice={isShowPrice}
      isShowLanguages={isShowLanguages}
      logoHref={logoHref}
      languages={languages}
      learn={learn}
      isShowGeoIcon={isShowGeoIcon}
      learn_desktop={learn_desktop}
    />
  )
}

export const GlobalNavbar = () => <GeneralNavbar region="global" />
export const USNavbar = () => <GeneralNavbar region="us" />
export const EEANavbar = () => <GeneralNavbar region="eea" />
export const SGNavbar = () => <GeneralNavbar region="sg" />
export const AUNavbar = () => <GeneralNavbar region="au" />
export const BRNavbar = () => <GeneralNavbar region="br" />
export const TRNavbar = () => <GeneralNavbar region="tr" />
export const FRNavbar = () => <GeneralNavbar region="fr" />
